package gr.tech.meetinggenie.models.meeting

import kotlinx.serialization.Serializable

@Serializable
data class WinDTO(
    var dealName: String = "",
    var dealSizeOrImpact: String = "",
    var whyThisWinMatters: String = "",
    var winSize: Int = 1  // radio: 1, 2, or 3
)

@Serializable
data class MeetingFormDataDTO(
    var wins: List<WinDTO> = listOf(),
    var losses: List<LossDTO> = listOf(),
    var activeProjects: List<ActiveProjectDTO> = listOf(),
    var closingSoon: List<ClosingSoonDTO> = listOf(),
    var projectUpdates: List<ProjectUpdateDTO> = listOf(),
    var weeklySummary: WeeklySummaryDTO = WeeklySummaryDTO(),
    var pulseCheck: PulseCheckDTO = PulseCheckDTO(),
)
